<div class="fixed transform z-2" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-0 pb-0">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>Facility Dashboard</a></div>
    </div>
  </div>
</div>
<p-table #dt [value]="bodyFacilityImprovefacilityList" [rows]="10" styleClass="p-datatable-striped p-datatable-gridlines overflow-x-auto" responsiveLayout="scroll" [rowHover]="true"
  sortMode="multiple" (sortFunction)="customSort($event)" [customSort]="true" [resizableColumns]="true" columnResizeMode="expand">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="{{headerFacilityList}}" pResizableColumn
          *ngFor="let headerFacilityList of headerFacilityImprovefacilityList let d = index"> {{headerFacilityList}} <p-sortIcon *ngIf="!headerFacilityList.includes('Graphs')" field="{{headerFacilityList}}"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-bodyFacilityImprovefacilityList let-i="rowIndex">
    <tr>
      <td><button pButton pRipple type="button" [label]="loading[i] == undefined || loading[i] == false ? 'View' : ' '"
          [loading]="loading[i]" style="width: 58px; height: 35px;"
          (click)="getChartValues(bodyFacilityImprovefacilityList, i)"></button></td>
<ng-container *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList; let j=index">
  <td [style]="GetBackgroundColor(bodyFacilityImprovefacilityList, subBodyFacilityList, j)"> {{subBodyFacilityList}} </td>
</ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <h5 *ngIf="totalRecords == 0" class="text-center">
        <b> No records found</b>
      </h5>
    </tr>
  </ng-template>

</p-table>
<div class="md:col-12">
  <span class="tableRefreshTime">
    Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
  </span>
</div>
<!-- ---------------Diaglog For Chart---------------------- -->

<p-dialog [(visible)]="chartBool" [breakpoints]="{'960px': '75vw'}" [draggable]="false" [style]="{width: '80%'}"
  [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="header">
    <span>
      <p-button *ngIf="!chartFoundBool" type="button" icon="pi pi-file-pdf" [loading]="loaders.value" (click)="exportPdf()"
        [loading]="exportPdfLoader" label="Save as PDF" class="p-button-primary mr-1"></p-button>
    </span>
  </ng-template>
  <ng-template pTemplate="content">
    <p-toast position="top-right"></p-toast>
    <div class="p-fluid formgrid">
      <div class="chart-popup bg-default px-3 pb-3" id="htmlData">
        <span *ngIf="!barBool && !chartFoundBool">
          <kendo-chart>
              <kendo-chart-title
                [text]="chartsTitle"
                color="black"
                [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                [align]="titleAlignment.align" 
                [margin]="{ bottom: 40 }">
              </kendo-chart-title>

              <kendo-chart-legend  position="bottom"
              [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="lineChartCategories">
                <kendo-chart-category-axis-item-labels 
                font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                </kendo-chart-category-axis-item-labels>
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
           
            <kendo-chart-value-axis>
              <kendo-chart-value-axis-item [min]="minDate" [max]="maxdoortostartmeancal + 80000">
                <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif" color="#000000">
          </kendo-chart-value-axis-item-labels>
              </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>
            
            <kendo-chart-series>
              <kendo-chart-series-item [data]="doortostartmeancal" [spacing]="0.25" [gap]="1"
              type="line" smooth="true" [style]="style"
              [name]="name" [color]="series.color"
              [labels]="seriesLabels" [missingValues]="'interpolate'"> 
              <kendo-chart-series-item-labels *ngIf="labelContent && labelContent.length" [background]="'transparent'" [content]="labelContent" [color]="series.colorLabel" [font]="screenWidth < 1300 ? seriesWidth.font : series.font"> </kendo-chart-series-item-labels>
            </kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>
        </span>
          <span *ngIf="barBool && !chartFoundBool"> 
          <kendo-chart [seriesColors]="seriesColors">
            <kendo-chart-title
                [text]="chartsTitle"
                color="black"
                [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                [align]="titleAlignment.align"
                [margin]="{ bottom: 40 }">
            </kendo-chart-title>

              <kendo-chart-legend position="bottom"
              [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="barChartCategories">

                <kendo-chart-category-axis-item-labels 
                font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                </kendo-chart-category-axis-item-labels>

              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>

            <kendo-chart-value-axis>
              <kendo-chart-value-axis-item [labels]="valueAxisLabels">
              </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>

            <kendo-chart-series>
              <kendo-chart-series-item [data]="barChartDatasets" [spacing]="0.25" [gap]="1"
              [name]="name" [color]="series.color" smooth="true"
              [labels]="seriesLabels"> 
            </kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>
        </span>
      </div>
<div class="chart-popup bg-default px-3 pb-3" *ngIf="chartFoundBool">
  <h4 class="text-center create-roles w-full"><b> No Data Available For Graphs </b></h4>
</div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
      <button pButton type="button" *ngIf="!chartFoundBool" (click)="hideChartDiaglog()" class=" btn-UnCancelCase">
        <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
  </ng-template>
</p-dialog>
